<template>
   <div class="flex w-fit flex-col gap-1" :class="{ 'w-full': grow }">
      <Label v-if="label" :disabled="disabled">{{ label }}</Label>
      <div class="text-primary relative">
         <select
            v-model="model"
            ref="selectRef"
            class="bg-light-grey rounded-small p-m box-border h-10 appearance-none pl-4 pr-8 outline-0 disabled:opacity-60"
            :class="{
               [`${$attrs.class}`]: true,
               __clickable: !disabled,
               'bg-white': white,
               'border-red border': error,
               'text-grey': model == null,
               '!m-0 h-fit !bg-transparent !p-0': unstyled,
               'w-full': grow,
            }"
            :disabled="disabled"
         >
            <option v-if="placeholderText" :value="undefined" disabled>
               {{ placeholderText }}
            </option>
            <option
               v-for="option in options"
               :key="option.id"
               :value="option.id"
               :disabled="option.disabled"
            >
               {{ option.value }}
            </option>
         </select>

         <div
            v-if="!unstyled"
            class="pointer-events-none absolute inset-y-0 right-2 flex items-center"
         >
            <Icon
               :name="icon || 'chevron-down-mini'"
               class="size-5"
               :class="{ 'text-red': error }"
            />
         </div>
      </div>
   </div>
</template>

<script lang="ts" setup>
import type { SelectOption } from '@xleddyl/types'

type Props = {
   placeholder?: string
   label?: string
   options?: SelectOption[]
   icon?: string
   disabled?: boolean
   white?: boolean
   error?: string
   grow?: boolean
   unstyled?: boolean
   slotBefore?: boolean
}

const props = withDefaults(defineProps<Props>(), {})
const model = defineModel<string | boolean | number | undefined>()

const placeholderText = computed(() => {
   if (props.placeholder) return props.placeholder
   const undefinedOption = props.options?.find((o) => o.id == null)
   return undefinedOption?.value
})

const selectRef = ref<HTMLSelectElement>()

defineExpose({ selectRef })
</script>
